<div
  class="d-flex justify-content-center loader flex-column align-items-center"
  *ngIf="saving"
>
  <div>
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

  <ng-container
    *ngIf="profileForm"
  >

        <form class="user" [formGroup]="profileForm" (ngSubmit)="saveProfile()">
          <div class="row p-3 d-flex justify-content-center">
            <div
              class="col-md-12 business-photo-field d-flex flex-column align-items-center mb-4"
              [class.has-error]="profileForm.controls.ProfilePicture.invalid && profileForm.controls.ProfilePicture.touched"
            >
              <input type="file" class="file-input" (change)="onFileSelected($event)" #fileInput style="display: none" accept="image/*" />
              <span class="required-badge">Required</span>
              <h2 class="photo-title">Add your business profile picture</h2>
              <p class="photo-help">This is the main image customers will see on your listing and preview.</p>
              <button type="button" class="photo-upload-button" (click)="uploadFile()" aria-label="Choose a business profile picture">
                <img class="img-fluid border-radius-5 shadow" [src]="webcamImageDisplaySrc" alt="Business profile picture preview" />
                <span>{{ uploadedImage || profileForm.controls.ProfilePicture.value ? 'Change picture' : 'Choose picture' }}</span>
              </button>
              <mat-error *ngIf="profileForm.controls.ProfilePicture.invalid && profileForm.controls.ProfilePicture.touched">
                Add a business profile picture to save and preview your listing.
              </mat-error>
            </div>
          </div>
          <div class="d-flex row p-3">
            <div class="col-md-6 d-flex flex-column">
              <mat-form-field appearance="outline">
                <mat-label>Business name</mat-label>
                <input
                  matInput
                  placeholder="Name"
                  name="name"
                  formControlName="Name"
                />
                <mat-error *ngIf="profileForm.controls.Name.invalid"
                  >Name is Required</mat-error
                >
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>About</mat-label>
                <textarea
                  rows="6"
                  matInput
                  placeholder="About"
                  name="About"
                  formControlName="About"
                ></textarea>
                <mat-error *ngIf="profileForm.controls.About.invalid"
                  >About is Required</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline" *ngIf="!selectedCategory">
                <mat-label>Category</mat-label>
                <mat-select
                  formControlName="Category"
                  [compareWith]="compareFn"
                >
                  <mat-option
                    *ngFor="let category of categories"
                    [value]="category"
                    >{{ category.name }}</mat-option
                  >
                </mat-select>
                <mat-error *ngIf="profileForm.controls.Category.invalid"
                  >Category is Required</mat-error
                >
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Website</mat-label>
                <input matInput placeholder="URL" formControlName="Website" />
              </mat-form-field>
              <mat-form-field class="w-100" appearance="fill">
                <mat-label>City</mat-label>
                <input type="text"
                      placeholder="City"
                      aria-label="City"
                      matInput
                      formControlName="City"
                      [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  <mat-option *ngFor="let option of filteredCities | async" [value]="option.city">
                    {{option.city}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Address</mat-label>
                <textarea
                  rows="4"
                  matInput
                  placeholder="Address"
                  formControlName="Address"
                ></textarea>
                <mat-error *ngIf="profileForm.controls.Address.invalid"
                  >Address is Required</mat-error
                >
              </mat-form-field>
                            <div class="d-flex flex-column border-primary p-2">
                            <h3>Trading hours</h3>
                              
              <div formArrayName="TradingHours">
                <div *ngFor="let day of tradingHoursControls?.controls; index as i" [formGroupName]="i">
                  <div class="d-flex p-0 align-items-center flex-wrap">
                    <p class="m-0 flex-1">{{ day.controls['day'].value }}</p>
                    <mat-slide-toggle formControlName="open"></mat-slide-toggle>
                        <input class="flex-1 m-2 border-radius-5" type="time" placeholder="Open" formControlName="startTime" />
                        <input class="flex-1 m-2 border-radius-5" type="time" placeholder="Close" formControlName="endTime" />
                  </div>

                </div>
              </div>
              </div>
            </div>
            <div class="col-md-6 d-flex flex-column">
              <mat-form-field appearance="outline">
                <mat-label>Mobile</mat-label>
                <input matInput placeholder="Mobile" formControlName="Mobile" />
                <mat-error *ngIf="profileForm.controls.Mobile.invalid"
                  >Mobile is Required</mat-error
                >
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput placeholder="Email" formControlName="Email" />
                <mat-error *ngIf="profileForm.controls.Email.invalid"
                  >Email is Required</mat-error
                >
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Registration Number</mat-label>
                <input
                  matInput
                  placeholder="RegistrationNumber"
                  formControlName="RegistrationNumber"
                />
                <mat-error
                  *ngIf="profileForm.controls.RegistrationNumber.invalid"
                  >Registration Number is Required</mat-error
                >
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Registration Date</mat-label>
                <input
                  matInput
                  placeholder="RegistrationDate"
                  formControlName="RegistrationDate"
                />
                <mat-error
                  *ngIf="profileForm.controls.RegistrationNumber.invalid"
                  >Registration Date is Required</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Owner Name</mat-label>
                <input
                  matInput
                  placeholder="OwnershipInfo"
                  formControlName="OwnershipInfo"
                />
                <mat-error *ngIf="profileForm.controls.OwnershipInfo.invalid"
                  >Ownership info is Required</mat-error
                >
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Owner ID</mat-label>
                <input
                  matInput
                  placeholder="Owner ID"
                  name="OwnerID"
                  formControlName="OwnerID"
                />
                <mat-error *ngIf="profileForm.controls.OwnerID.invalid"
                  >Owner ID Required</mat-error
                >
              </mat-form-field>
              <mat-form-field *ngIf="currentUser.get('role') === 'admin'" appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="Status">
                  <mat-option></mat-option>
                  <mat-option
                    *ngFor="let status of statusArray"
                    [value]="status"
                    >{{ status }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
                            <app-map
                style="min-width: 400px"
                [location]="profileForm.controls.Address.value"
                *ngIf="profileForm.controls.Address.valid"
              ></app-map>
            </div>
            <div class="col-md-12 d-flex flex-column align-items-center mt-3">
              <h2 class="m-0" id="Consent">
                I accept the
                <a
                  href="https://advibe.b4a.app/terms-and-conditions"
                  target="_blank"
                  >Terms of Service</a
                >?
              </h2>
              <mat-radio-group
                aria-labelledby="Consent"
                formControlName="InformedDataConsent"
              >
                <mat-radio-button
                  class="example-radio-button m-3"
                  [value]="true"
                >
                  Yes
                </mat-radio-button>
                <mat-radio-button
                  class="example-radio-button m-3"
                  [value]="false"
                >
                  No
                </mat-radio-button>
              </mat-radio-group>
              <mat-error
                *ngIf="
                  profileForm.controls['InformedDataConsent'].errors ||
                  (!business?.InformedDataConsent &&
                    !profileForm.controls['InformedDataConsent'].value)
                "
                >In order for you to use the platform we need your
                consent.</mat-error
              >
            </div>
          </div>
          <mat-toolbar class="d-flex justify-content-end">
            <button
              type="submit"
              [disabled]="saving"
              mat-raised-button
              color="primary"
            >
              {{ saving ? "Saving..." : (deferSave ? "Next" : (profile ? "Update Business Profile" : "Create business and preview")) }}
            </button>
          </mat-toolbar>
        </form>
</ng-container>
